import { useEffect, useState } from 'react';

/**
 * Material "hide bottom bar on scroll" (HideBottomViewOnScrollBehavior): hide while the user
 * scrolls down, show again as soon as they scroll up. A small threshold ignores jitter, and the
 * bar is always shown near the top of the page.
 */
export const useHideOnScroll = ({ threshold = 8, topOffset = 56 } = {}) => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let lastY = window.scrollY;
    let frame = 0;
    const update = () => {
      frame = 0;
      const y = Math.max(0, window.scrollY);
      const delta = y - lastY;
      if (y <= topOffset) setHidden(false);
      else if (Math.abs(delta) < threshold) return;
      else setHidden(delta > 0);
      lastY = y;
    };
    const onScroll = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (frame) cancelAnimationFrame(frame);
    };
  }, [threshold, topOffset]);

  return hidden;
};
